// IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916)
// «ІСТОРІЯ ЗМІН» СПИСКА ПО DS (WIDGET-LIST на DATA-SOURCE-*) — чистая логика без store: подвкладки «Джерела» и «Визначення DS», ключи строк страницы
// (params.history.page_keys) и «Показати у списку» (оверлей WHERE в памяти виджета). Контракт v2 (ANSWERS-BE 29.10):
//   sources[{ segment, title, kind, kind_title*, journal_coverage audit|manual_only|none, coverage full|keys|none, via, via_title*, key_spec, row_key_cols,
//     events, packets, records, linked_rows, recalc_unknown }]; keys{ mode ids|page, n, cols, capped, title* }; unlinked{ title*, sources[] };
//   definition[{ at, by, op, ds_id, ds_title, audit_id, fields[{ f, kind text|rows, title*, lines_from, lines_to, added, removed,
//     rows_from, rows_to, rows_changed, has_text }] }] — тексты text_from / text_to / truncated ТОЛЬКО в ответе раскрытия
//     (запрос definition_audit_id → record._doc.list_history_detail, for.definition_audit_id);
//   пакеты источников: id 's<N>p<hash>' (N — номер источника в sources[], с 1), 'l<hash>' (загрузки), 'r<hash>' (перерасчёты); у пакета
//     журнала без привязки к строкам unlinked: true (только счётчики); события раскрытия несут source_segment, rows[] (ключи строк), rows_more.
// «Показати у списку»: ключи rows события → строка WHERE виджета-списка (чипс, метка _lhOverlay: true) — только в памяти (params.WHERE ЗАПИСИ виджета, не стола);
// пары object::subject дают фильтр по object (шире — wider: true). Оболочка перечитывает список (select) и снимает чипс кнопкой / ⊗.
import { listHistory_title, listHistory_at, listHistory_state, listHistory_detailInfo } from './listHistory.js'
import { pmHistory_fmt } from './pmHistory.js'

export const LHD_OVERLAY_KEY = '_lhOverlay'   // метка строки WHERE оверлея «Показати у списку»
export const LHD_OVERLAY_MAX = 300   // значений в одном чипсе (rows события ≤ 20 + rows_more; запас на несколько событий)
export const LHD_PAGE_KEYS_MAX = 5000   // потолок ключей страницы, если ответ не назвал ids_max
export const LHD_KEY_COLS = ['id', 'object', 'subject']   // колонки ключа, которые понимает бэк (list_history_ds.KEY_COLS)
export const LHD_KEY_SEP = '::'   // разделитель ключа пары object::subject
export const LHD_DIFF_CONTEXT = 3   // строк контекста вокруг изменённых в дифф-просмотре определения
export const LHD_DIFF_CELLS = 4000000   // потолок ячеек LCS (n × m); больше — блок «удалено / добавлено» без выравнивания

const num = (v) => { const n = Number(v); return Number.isFinite(n) ? n : 0 }
const str = (v) => (v == null ? '' : String(v))
const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)
const arr = (v) => (Array.isArray(v) ? v : [])
const idT = (s, p) => str(s).replace(/\{(\w+)\}/g, (m, k) => (p && k in p ? String(p[k]) : m))
const tr = (t, s, p) => (typeof t === 'function' ? t(s, p) : idT(s, p))
// подпись по ключу-основе: base / base_uk / base_ru (kind_title, via_title, coverage_title, title)
const ttl = (o, base, lang) => {
    if (!isObj(o)) return ''
    const L = str(lang).toLowerCase()
    return ((L === 'uk' || L === 'ru') ? str(o[base + '_' + L]) : '') || str(o[base])
}

export function listHistoryDs_isDs(p) { return isObj(p) && str(p.mode) === 'ds' }

// ===================================================================================== ДЖЕРЕЛА
// плашка журнала источника: audit | manual_only | none → { key, text, cls }
export function listHistoryDs_journalPill(src, t) {
    const k = str(isObj(src) ? src.journal_coverage : '')
    if (k === 'audit') return { key: 'audit', text: tr(t, 'Journal'), cls: 'audit' }
    if (k === 'manual_only') return { key: 'manual_only', text: tr(t, 'Manual edits only'), cls: 'manual_only' }
    return { key: 'none', text: tr(t, 'No journal'), cls: 'none' }
}
// «связь с рядками списка» по coverage источника: full | keys | none → { key, text, cls }
export function listHistoryDs_linkInfo(src, t) {
    const S = isObj(src) ? src : {}
    const k = str(S.coverage)
    if (k === 'full') return { key: 'full', text: tr(t, 'Linked to list rows'), cls: 'full' }
    if (k === 'keys') return { key: 'keys', text: tr(t, 'Not linked to list rows'), cls: 'keys' }
    return { key: 'none', text: tr(t, 'No journal — recalculations only'), cls: 'none' }
}

// ТАБЛИЦА ИСТОЧНИКОВ: → [{ key, idx (номер источника с 1 — как в id пакетов 's<N>p…'), segment, title, kindText, viaText, journal, link, recalcUnknown, recalcText,
//   events, packets, records, linkedRows, rowKeyCols, canShow (журнал привязан к строкам — «Показати у списку» возможен) }]
export function listHistoryDs_sourcesRows(p, lang = 'en', t) {
    return arr(isObj(p) ? p.sources : null).filter(isObj).map((s, i) => {
        const via = ttl(s, 'via_title', lang) || (str(s.via) ? tr(t, 'via {via}', { via: str(s.via) }) : '')
        const cols = arr(s.row_key_cols).map(str).filter(Boolean)
        const link = listHistoryDs_linkInfo(s, t)
        return {
            key: str(s.segment) + '#' + (i + 1), idx: i + 1, segment: str(s.segment), title: ttl(s, 'title', lang) || str(s.segment),
            kindText: ttl(s, 'kind_title', lang) || str(s.kind), viaText: via,
            journal: listHistoryDs_journalPill(s, t), link,
            recalcUnknown: s.recalc_unknown === true, recalcText: s.recalc_unknown === true ? tr(t, 'No traces of recalculation found') : '',
            events: num(s.events), packets: num(s.packets), records: num(s.records), linkedRows: num(s.linked_rows),
            rowKeyCols: cols, canShow: link.key === 'full' && cols.length > 0,
        }
    })
}

// шапка источников: как ключи выдачи привязаны к рядкам → { text, warn, canBindPage (режим page — можно прислать ключи видимой страницы), unlinked }
export function listHistoryDs_keysNote(p, lang = 'en', t) {
    const out = { text: '', warn: false, canBindPage: false, unlinked: '' }
    const K = isObj(p) && isObj(p.keys) ? p.keys : null
    if (K) {
        const n = pmHistory_fmt(num(K.n))
        if (str(K.mode) === 'page') { out.text = tr(t, 'Rows are bound by the visible page: {n} keys', { n }); out.canBindPage = true }
        else out.text = tr(t, 'Rows are bound by the list filter: {n} keys', { n })
        if (K.capped === true) { out.text += ' · ' + tr(t, 'the filter is larger than the limit — only the first keys are used'); out.warn = true }
    }
    const U = isObj(p) && isObj(p.unlinked) ? p.unlinked : null
    if (U && arr(U.sources).length) out.unlinked = tr(t, 'Not linked to list rows: {names}', { names: arr(U.sources).map(str).join(', ') })
    return out
}

// номер источника из id пакета 's<N>p<hash>' (с 1); 0 — пакет не источника (загрузка 'l…', перерасчёт 'r…', чужой формат)
export function listHistoryDs_packetSourceNo(id) {
    const m = /^s(\d+)p/.exec(str(id))
    return m ? Number(m[1]) : 0
}
// пакеты одного источника (по номеру) + загрузки / перерасчёты, чей source_segment совпал (если бэк его прислал): → [{ id, title, when, events, records, unlinked, open, kind }]
export function listHistoryDs_sourcePackets(p, idx, lang = 'en', t, ui = null) {
    const open = str(isObj(ui) ? ui.packetOpen : '')
    return arr(isObj(p) ? p.packets : null).filter(x => isObj(x) && listHistoryDs_packetSourceNo(x.id) === Number(idx)).map(x => ({
        id: str(x.id), kind: str(x.kind), title: ttl(x, 'title', lang) || str(x.task_title) || str(x.id),
        when: str(x.at_from) && str(x.at_to) && x.at_from !== x.at_to ? listHistory_at(x.at_from) + ' — ' + listHistory_at(x.at_to) : listHistory_at(x.at_from || x.at_to),
        events: num(x.events), records: num(x.records), unlinked: x.unlinked === true, open: str(x.id) === open,
        note: x.unlinked === true ? tr(t, 'counters only — the journal is not linked to list rows') : '',
    }))
}

const OP_TEXT = { I: 'Created', U: 'Changed', A: 'Archived', R: 'Restored', D: 'Deleted' }
// события раскрытого пакета источника: → { items: [{ key, at, opText, title, rows, rowsMore, show }], total, offset, next, error, wait }
// show = { rows, cols, source_segment, more } — полезная нагрузка 'show-in-list' (null: у события нет ключей строк или источник не привязан)
export function listHistoryDs_sourceEvents(detail, p, ui, lang = 'en', t) {
    const I = listHistory_detailInfo(detail)
    const open = str(isObj(ui) ? ui.packetOpen : '')
    const mine = I.kind === 'packet' && I.id === open && !!open
    const out = { items: [], total: 0, offset: 0, next: null, error: '', wait: !!(isObj(ui) && ui.detailWait) && !mine }
    if (!mine) return out
    if (I.error) { out.error = I.error; return out }
    out.total = I.total; out.offset = I.offset; out.next = I.next
    const srcs = arr(isObj(p) ? p.sources : null)
    out.items = I.events.filter(isObj).map((e, i) => {
        const src = srcs.find(s => isObj(s) && str(s.segment) === str(e.source_segment)) || srcs[listHistoryDs_packetSourceNo(open) - 1] || null
        const label = str(e.record_label) || str(e.record_title) || str(e.record_id)
        return { key: str(e.audit_id) || (str(e.at) + '#' + i), at: listHistory_at(e.at), opText: tr(t, OP_TEXT[str(e.op)] || 'Changed'), title: label,
            rows: arr(e.rows).map(str).filter(Boolean).length, rowsMore: num(e.rows_more), show: listHistoryDs_showPayload(e, src) }
    })
    return out
}

// ПОЛЕЗНАЯ НАГРУЗКА 'show-in-list' из события источника: { rows, cols, source_segment, more } | null (нет ключей / колонок ключа нет — источник не привязан)
export function listHistoryDs_showPayload(event, source) {
    const rows = arr(isObj(event) ? event.rows : null).map(str).filter(Boolean)
    const cols = arr(isObj(source) ? source.row_key_cols : null).map(str).filter(Boolean)
    if (!rows.length || !cols.length) return null
    return { rows, cols, source_segment: str(event.source_segment) || str(source.segment), more: num(event.rows_more) }
}

// ===================================================================================== ВИЗНАЧЕННЯ DS
const DEF_OP = { I: 'Created', U: 'Changed', D: 'Deleted' }
// одна строка «поле: было → стало» из definition[].fields[] основного ответа (тексты — только в раскрытии)
export function listHistoryDs_fieldLine(f, lang = 'en', t) {
    const F = isObj(f) ? f : {}
    const title = ttl(F, 'title', lang) || str(F.f)
    if (str(F.kind) === 'rows') {
        const a = num(F.rows_from), b = num(F.rows_to), c = num(F.rows_changed)
        if (F.rows_from == null && F.rows_to == null) return title
        return c > 0 ? tr(t, '{title}: {from} → {to} ({changed} changed)', { title, from: a, to: b, changed: c }) : tr(t, '{title}: {from} → {to}', { title, from: a, to: b })
    }
    if (F.lines_from == null && F.lines_to == null) return title
    return tr(t, '{title}: {from} → {to} lines (+{added} / −{removed})', { title, from: num(F.lines_from), to: num(F.lines_to), added: num(F.added), removed: num(F.removed) })
}
// СПИСОК СОБЫТИЙ ОПРЕДЕЛЕНИЯ (по убыванию времени, как пришли): → [{ key, auditId, at, by, ds, opText, fields: [{ f, line, hasText }], hasText, open }]
export function listHistoryDs_definitionRows(p, lang = 'en', t, ui = null) {
    const openId = str(isObj(ui) ? ui.definitionOpen : '')
    return arr(isObj(p) ? p.definition : null).filter(isObj).map((d, i) => {
        const fields = arr(d.fields).filter(isObj).map(f => ({ f: str(f.f), line: listHistoryDs_fieldLine(f, lang, t), hasText: f.has_text === true }))
        const auditId = str(d.audit_id)
        return { key: auditId || (str(d.at) + '#' + i), auditId, at: listHistory_at(d.at), by: str(d.by), ds: str(d.ds_title) || str(d.ds_id),
            opText: tr(t, DEF_OP[str(d.op)] || 'Changed'), fields, hasText: fields.some(f => f.hasText) && !!auditId, open: !!auditId && auditId === openId }
    })
}
// запрос раскрытия определения: патч params.history (оболочка шлёт его как detail и подставляет answer_id)
export function listHistoryDs_definitionRequest(row) { return row && str(row.auditId) ? { definition_audit_id: str(row.auditId) } : null }

// ТЕКСТЫ ОПРЕДЕЛЕНИЯ из ответа раскрытия: → { ready, error, fields: [{ f, title, kind, from, to, truncated, diff }] }; diff — listHistoryDs_lineDiff (для kind text / rows)
export function listHistoryDs_definitionTexts(detail, auditId, lang = 'en') {
    const out = { ready: false, error: '', fields: [] }
    const I = listHistory_detailInfo(detail)
    if (I.kind !== 'definition' || I.id !== str(auditId) || !str(auditId)) return out
    if (I.error) { out.error = I.error; return out }
    if (listHistory_state(detail) === 'error' || (isObj(detail) && detail.found === false)) { out.error = 'not found'; return out }
    out.ready = true
    const ev = arr(detail.definition).find(d => isObj(d) && (!str(d.audit_id) || str(d.audit_id) === str(auditId))) || arr(detail.definition)[0]
    out.fields = arr(isObj(ev) ? ev.fields : null).filter(isObj).map(f => {
        const from = f.text_from == null ? '' : str(f.text_from), to = f.text_to == null ? '' : str(f.text_to)
        return { f: str(f.f), title: ttl(f, 'title', lang) || str(f.f), kind: str(f.kind), from, to, truncated: f.truncated === true, hasText: f.text_from != null || f.text_to != null, diff: listHistoryDs_lineDiff(from, to) }
    })
    return out
}

// ПОСТРОЧНЫЙ ДИФФ (LCS по строкам; общие начало и конец срезаются): → { lines: [{ op: ctx|add|del|gap, text, skipped? }], added, removed, same }
// Контекст вокруг изменений — LHD_DIFF_CONTEXT строк, остальное сворачивается в { op: 'gap', skipped: N }. Огромный текст (n × m > LHD_DIFF_CELLS) — без выравнивания.
export function listHistoryDs_lineDiff(from, to, o = {}) {
    const ctx = o.context != null ? Math.max(0, num(o.context)) : LHD_DIFF_CONTEXT
    const A = str(from).split('\n'), B = str(to).split('\n')
    let s = 0
    while (s < A.length && s < B.length && A[s] === B[s]) s++
    let ea = A.length, eb = B.length
    while (ea > s && eb > s && A[ea - 1] === B[eb - 1]) { ea--; eb-- }
    const a = A.slice(s, ea), b = B.slice(s, eb)
    const mid = []   // изменённая середина: del / add / ctx
    if (a.length * b.length > (o.cells || LHD_DIFF_CELLS)) {
        a.forEach(x => mid.push({ op: 'del', text: x })); b.forEach(x => mid.push({ op: 'add', text: x }))
    } else {
        const n = a.length, m = b.length
        const L = Array.from({ length: n + 1 }, () => new Int32Array(m + 1))
        for (let i = n - 1; i >= 0; i--) for (let j = m - 1; j >= 0; j--) L[i][j] = a[i] === b[j] ? L[i + 1][j + 1] + 1 : Math.max(L[i + 1][j], L[i][j + 1])
        let i = 0, j = 0
        while (i < n && j < m) {
            if (a[i] === b[j]) { mid.push({ op: 'ctx', text: a[i] }); i++; j++ }
            else if (L[i + 1][j] >= L[i][j + 1]) mid.push({ op: 'del', text: a[i++] })
            else mid.push({ op: 'add', text: b[j++] })
        }
        while (i < n) mid.push({ op: 'del', text: a[i++] })
        while (j < m) mid.push({ op: 'add', text: b[j++] })
    }
    const all = [...A.slice(0, s).map(x => ({ op: 'ctx', text: x })), ...mid, ...A.slice(ea).map(x => ({ op: 'ctx', text: x }))]
    const added = all.filter(x => x.op === 'add').length, removed = all.filter(x => x.op === 'del').length
    if (!added && !removed) return { lines: [], added: 0, removed: 0, same: true }
    // сворачиваем длинные куски контекста
    const keep = new Array(all.length).fill(false)
    all.forEach((x, k) => { if (x.op !== 'ctx') for (let d = -ctx; d <= ctx; d++) if (k + d >= 0 && k + d < all.length) keep[k + d] = true })
    const lines = []
    let gap = 0
    all.forEach((x, k) => {
        if (keep[k]) { if (gap) { lines.push({ op: 'gap', text: '', skipped: gap }); gap = 0 } lines.push(x) } else gap++
    })
    if (gap) lines.push({ op: 'gap', text: '', skipped: gap })
    return { lines, added, removed, same: !added && !removed }
}

// ===================================================================================== КЛЮЧИ СТРАНИЦЫ (params.history.page_keys)
// ячейка строки списка → текст ключа: ссылка приходит объектом { value, valueStr }, число / строка — как есть; пусто / объект / массив — ''
// (правила pageGotoChip_value; свои копии — чтобы модуль не тянул guidePlay и роутер)
function cellText(raw) {
    const v = isObj(raw) ? raw.value : raw
    if (v == null || v === '' || (typeof v === 'number' && Number.isNaN(v)) || isObj(v) || Array.isArray(v)) return ''
    return str(v)
}
// строка данных: не итог, не строка сравнения (_variant), не полоса / заголовок блока, не скрытая (правила pageGotoChip_rowIsData)
function rowIsData(r) {
    if (!isObj(r) || r._variant) return false
    const d = r._DLRow
    if (isObj(d) && (d.row_type === 'Total' || d.row_type === 'tab' || d.row_type === 'tabrow' || d.hide || d.memo)) return false
    return !r._ogHide
}
// ключи строк загруженной страницы списка: [{ id, object, subject }] (бэк: list_history_ds.page_keys) — строки данных, хотя бы одна колонка ключа непуста, без дублей.
// → { keys, n (всего подходящих строк), capped (обрезано по max), cols (какие колонки ключа есть в строках) }
export function listHistoryDs_pageKeys(rows, o = {}) {
    const max = Math.max(1, num(o.max) || LHD_PAGE_KEYS_MAX)
    const seen = new Set(), keys = [], cols = new Set()
    let n = 0
    for (const r of arr(rows)) {
        if (!isObj(r) || !rowIsData(r)) continue
        const k = {}
        let any = false
        for (const c of LHD_KEY_COLS) { k[c] = cellText(r[c]); if (k[c]) { any = true; cols.add(c) } }
        if (!any) continue
        const sig = k.id + '\u0001' + k.object + '\u0001' + k.subject
        if (seen.has(sig)) continue
        seen.add(sig); n++
        if (keys.length < max) keys.push(k)
    }
    return { keys, n, capped: n > keys.length, cols: LHD_KEY_COLS.filter(c => cols.has(c)) }
}
// строки выдачи виджета-списка: record._doc.data (так их читает multiply_fetchItems), запасной путь — record.doc.data
export function listHistoryDs_widgetRows(WIDGET) {
    const rec = isObj(WIDGET) ? WIDGET.record : null
    if (!isObj(rec)) return []
    if (Array.isArray(rec._doc && rec._doc.data)) return rec._doc.data
    if (isObj(rec.doc) && Array.isArray(rec.doc.data)) return rec.doc.data
    return []
}
// ответу нужны ключи страницы (DS тяжёлый, keys.mode = page)?
export function listHistoryDs_pageKeysWanted(p) { return listHistoryDs_isDs(p) && isObj(p.keys) && str(p.keys.mode) === 'page' }
// ключи страницы виджета для запроса: до settings_effective.ids_max ответа
export function listHistoryDs_pageKeysOf(WIDGET, p) {
    const se = isObj(p) && isObj(p.settings_effective) ? p.settings_effective : {}
    return listHistoryDs_pageKeys(listHistoryDs_widgetRows(WIDGET), { max: num(se.ids_max) || LHD_PAGE_KEYS_MAX })
}

// ===================================================================================== «ПОКАЗАТИ У СПИСКУ» — оверлей WHERE
// значения фильтра из rows события и колонок ключа источника (cols = row_key_cols): ['id'] → id; ['object'] → object; ['object','subject'] → object из 'object::subject'
// (фильтр по одному object показывает больше, чем затронуто, — wider: true; точнее — подсветка по rowMatchSet)
export function listHistoryDs_overlayValues(rows, cols) {
    const C = arr(cols).map(str).filter(Boolean)
    const R = arr(rows).map(str).filter(Boolean)
    if (!C.length || !R.length) return { binding: '', values: [], wider: false, truncated: false }
    const pair = C.length > 1
    const binding = C[0]
    const vals = []
    for (const r of R) {
        const v = pair ? r.split(LHD_KEY_SEP)[0] : r
        if (v && !vals.includes(v)) vals.push(v)
    }
    return { binding, values: vals.slice(0, LHD_OVERLAY_MAX), wider: pair, truncated: vals.length > LHD_OVERLAY_MAX }
}
// строка WHERE чипса (форма — как у pageGotoChip_apply: AttrChipWhere, condition in, значения в attrs) с меткой _lhOverlay
export function listHistoryDs_overlayRow(binding, values) {
    const link = (value, valueStr) => ({ attr_type: 'AttrLink', component: 'AttrLink', relation_segment: '', value, valueStr })
    return { use: true, attr_type: 'AttrChipWhere', condition: 'in', [LHD_OVERLAY_KEY]: true,
        leftValue: link(binding, binding), rightValue: link('', ''),
        attrs: values.map(v => ({ use: true, rightValue: link(v, v) })) }
}
const isOverlayRow = (r) => isObj(r) && r[LHD_OVERLAY_KEY] === true
const rowSig = (r) => JSON.stringify([isObj(r.leftValue) ? r.leftValue.value : r.leftValue, r.condition, arr(r.attrs).map(a => isObj(a) && isObj(a.rightValue) ? a.rightValue.value : '')])

// НАЛОЖИТЬ: show = { rows, cols } (событие 'show-in-list'). params — params записи виджета-списка (меняется на месте: params.WHERE получает строку-оверлей, прежний оверлей заменяется,
// остальные строки не трогаются). Идемпотентно: тот же набор — changed: false. → { changed, count, binding, wider, truncated, reason }
export function listHistoryDs_overlayApply(params, show) {
    const none = (reason) => ({ changed: false, count: 0, binding: '', wider: false, truncated: false, reason })
    if (!isObj(params)) return none('noParams')
    const S = isObj(show) ? show : {}
    const ov = listHistoryDs_overlayValues(S.rows, S.cols)
    if (!ov.binding || !ov.values.length) return none('noKeys')
    const row = listHistoryDs_overlayRow(ov.binding, ov.values)
    const had = Array.isArray(params.WHERE)
    const cur = had ? params.WHERE : []
    const old = cur.filter(isOverlayRow)
    const res = { count: ov.values.length, binding: ov.binding, wider: ov.wider, truncated: ov.truncated, reason: '' }
    if (old.length === 1 && rowSig(old[0]) === rowSig(row) && old[0].use !== false) return { changed: false, ...res }
    const next = [...cur.filter(r => !isOverlayRow(r)), row]
    if (!had) Object.defineProperty(next, '_lhNoWhere', { value: true, enumerable: false })   // WHERE не было вовсе — при снятии вернём «нет ключа»
    else if (cur._lhNoWhere) Object.defineProperty(next, '_lhNoWhere', { value: true, enumerable: false })
    params.WHERE = next
    return { changed: true, ...res }
}
// СНЯТЬ: убирает строки-оверлеи; остальной WHERE не трогает. Было пусто до оверлея — ключ WHERE удаляется (params возвращается к исходному виду). → { changed }
export function listHistoryDs_overlayClear(params) {
    if (!isObj(params) || !Array.isArray(params.WHERE) || !params.WHERE.some(isOverlayRow)) return { changed: false }
    const rest = params.WHERE.filter(r => !isOverlayRow(r))
    if (!rest.length && params.WHERE._lhNoWhere) delete params.WHERE
    else params.WHERE = rest
    return { changed: true }
}
// копия params без оверлея — для записи виджета (Save): оверлей в сохранённую запись попадать не должен. params не меняется
export function listHistoryDs_overlayStrip(params) {
    if (!isObj(params) || !Array.isArray(params.WHERE) || !params.WHERE.some(isOverlayRow)) return params
    const rest = params.WHERE.filter(r => !isOverlayRow(r))
    if (!rest.length && params.WHERE._lhNoWhere) { const out = { ...params }; delete out.WHERE; return out }   // IE 2026 10 29 / ODOO-5800 (K5): WHERE не было до оверлея — в сохранение без ключа
    return { ...params, WHERE: rest }
}
// IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916): K5 — копия ЗАПИСИ виджета без оверлея (record.doc.params.WHERE) для всего, что запись
// сохраняет (store.saveRecord и методы виджета, кроме читающих данные — образец cellRulesChip_strip); оверлея нет — та же запись (copy-on-write, запись в памяти не меняется)
export function listHistoryDs_overlayStripRecord(record) {
    const pr = isObj(record) && isObj(record.doc) ? record.doc.params : null
    const sp = listHistoryDs_overlayStrip(pr)
    return sp === pr ? record : { ...record, doc: { ...record.doc, params: sp } }
}
// состояние оверлея для плашки: → { active, count, binding }
export function listHistoryDs_overlayInfo(params) {
    const r = isObj(params) && Array.isArray(params.WHERE) ? params.WHERE.find(x => isOverlayRow(x) && x.use !== false) : null
    if (!r) return { active: false, count: 0, binding: '' }
    return { active: true, count: arr(r.attrs).length, binding: isObj(r.leftValue) ? str(r.leftValue.value) : '' }
}
// ключи строк для подсветки (запасной путь без WHERE): Set строк rows; строка списка → ключ по cols (id | object | object::subject)
export function listHistoryDs_rowMatchSet(rows) { return new Set(arr(rows).map(str).filter(Boolean)) }
export function listHistoryDs_rowKeyOf(row, cols) {
    const C = arr(cols).map(str).filter(Boolean)
    if (!isObj(row) || !C.length) return ''
    return C.map(c => cellText(row[c])).join(LHD_KEY_SEP)
}
